export default "__VITE_ASSET__DheldnOD__"